export default function HealthyIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "fill" | "fillOpacity">,
) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5021 3.77415C12.4596 2.01665 15.4846 2.07498 17.3705 3.96415C19.2555 5.85415 19.3205 8.86415 17.5671 10.8275L10.5005 17.9042L3.43547 10.8275C1.68214 8.86415 1.74797 5.84915 3.63214 3.96415C5.51964 2.07748 8.53881 2.01415 10.5021 3.77415ZM16.1905 5.14165C14.9405 3.88998 12.9238 3.83915 11.6155 5.01415L10.503 6.01248L9.38964 5.01498C8.07714 3.83832 6.06464 3.88998 4.81131 5.14332C3.56964 6.38498 3.50714 8.37248 4.65131 9.68582L10.5013 15.545L16.3513 9.68665C17.4963 8.37248 17.4338 6.38748 16.1905 5.14165Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
